import { Component } from '@angular/core';
import { CategoryNavigationComponent } from '@spartacus/storefront';
import { CategoryNavigationUIComponent } from '../category-navigation-ui/category-navigation-ui.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-category-navigation',
    templateUrl: './efa-category-navigation.component.html',
    imports: [CategoryNavigationUIComponent, NgClass, AsyncPipe, TranslatePipe]
})
export class EfaCategoryNavigationComponent extends CategoryNavigationComponent {}
